"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    UserBlockSolid: function() {
        return UserBlockSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const UserBlockSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsxs)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M12 1C9.23858 1 7 3.23858 7 6C7 8.76142 9.23858 11 12 11C14.7614 11 17 8.76142 17 6C17 3.23858 14.7614 1 12 1Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M12 12C6.47715 12 2 16.4772 2 22C2 22.5523 2.44772 23 3 23H14.5278C13.5777 21.9385 13 20.5367 13 19C13 16.3861 14.6715 14.1626 17.0039 13.3401C15.5321 12.4878 13.823 12 12 12Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M15 19C15 16.7909 16.7909 15 19 15C21.2091 15 23 16.7909 23 19C23 21.2091 21.2091 23 19 23C16.7909 23 15 21.2091 15 19ZM19 17C17.8954 17 17 17.8954 17 19C17 19.1792 17.0236 19.3528 17.0677 19.518L19.518 17.0677C19.3528 17.0236 19.1792 17 19 17ZM19 21C18.8208 21 18.6472 20.9764 18.482 20.9323L20.9323 18.482C20.9764 18.6472 21 18.8208 21 19C21 20.1046 20.1046 21 19 21Z",
            fill: "currentColor"
        })
    ]
}), "UserBlockSolid");
const _default = UserBlockSolid;
